/**
 * TPB Menu â€” tabbed category browser
 * -------------------------------------
 * Uses Shopify's public /collections/{handle}/products.json endpoint to
 * pull live product data (price, image, availability, tags) with no
 * backend needed. Sides are attached to the cart line as free line-item
 * properties via /cart/add.js â€” they show on the order but aren't
 * charged separately, matching the original "one side of your choice,
 * included" behavior.
 */
(function () {
  const grid = document.getElementById('tpbMenuGrid');
  const tabsWrap = document.getElementById('tpbTabs');
  const availToggle = document.getElementById('tpbAvailToggle');
  if (!grid || !tabsWrap) return;

  const collectionCache = {};
  let sidesOptionsCache = null;
  let currentTab = tabsWrap.querySelector('.tpb-tab-btn');
  let availableOnly = false;

  const sidesOverlay = document.getElementById('tpbSidesOverlay');
  const sidesList = document.getElementById('tpbSidesList');
  const sidesCount = document.getElementById('tpbSidesCount');
  const sidesConfirm = document.getElementById('tpbSidesConfirm');
  const sidesItemName = document.getElementById('tpbSidesItemName');
  const sidesEyebrow = document.getElementById('tpbSidesEyebrow');
  const sidesSub = document.getElementById('tpbSidesSub');
  const sidesMsg = document.getElementById('tpbSidesMsg');
  const toast = document.getElementById('tpbToast');

  let pendingVariantId = null;
  let pendingRequired = 0;
  let selectedSides = [];
  let selectedExtras = [];

  function showToast(msg) {
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 2600);
  }

  async function fetchCollection(handle) {
    if (collectionCache[handle]) return collectionCache[handle];
    try {
      const res = await fetch(`/collections/${handle}/products.json?limit=50`);
      if (!res.ok) return [];
      const data = await res.json();
      collectionCache[handle] = data.products || [];
      return collectionCache[handle];
    } catch (e) {
      console.error('Menu fetch failed for', handle, e);
      return [];
    }
  }

  async function getSidesOptions() {
    if (sidesOptionsCache) return sidesOptionsCache;
    const handle = tabsWrap.dataset.sidesHandle || 'sides';
    const products = await fetchCollection(handle);
    sidesOptionsCache = products.map(p => ({
      name: p.title,
      variantId: p.variants[0]?.id,
      price: p.variants[0] ? Number(p.variants[0].price) : null,
    }));
    return sidesOptionsCache;
  }

  function productCardHTML(p, sidesRequired) {
    const variant = p.variants[0];
    const price = variant ? `$${Number(variant.price).toFixed(0)}` : '';
    const image = p.images && p.images[0] ? p.images[0].src : null;
    const comingSoon = (p.tags || []).some(t => t.toLowerCase() === 'coming-soon');
    const soldOut = !variant || !variant.available;
    const disabled = comingSoon || soldOut;

    let btnLabel = `Add to Cart &mdash; ${price}`;
    if (comingSoon) btnLabel = 'Coming Soon';
    else if (soldOut) btnLabel = 'Sold Out';

    return `
      <div class="tpb-card ${disabled ? 'tpb-card-disabled' : ''}" data-available="${!disabled}">
        <div class="tpb-card-photo">
          ${image ? `<img src="${image}" alt="${p.title}" loading="lazy">` : ''}
        </div>
        <div class="tpb-card-body">
          <div class="tpb-row">
            <h3>${p.title}${comingSoon ? '<span class="tpb-tag tpb-tag-soon">Coming Soon</span>' : ''}${soldOut && !comingSoon ? '<span class="tpb-tag tpb-tag-soldout">Sold Out</span>' : ''}</h3>
            <span class="tpb-price">${price}</span>
          </div>
          ${p.body_html ? `<p>${p.body_html.replace(/<[^>]*>/g, '').slice(0, 110)}</p>` : ''}
          <button class="tpb-btn tpb-btn-primary tpb-add-btn" style="width:100%; justify-content:center; margin-top:14px;"
            ${disabled ? 'disabled' : ''}
            data-variant-id="${variant ? variant.id : ''}"
            data-name="${p.title}"
            data-sides="${sidesRequired}">${btnLabel}</button>
        </div>
      </div>`;
  }

  async function renderTab(tabBtn) {
    currentTab = tabBtn;
    tabsWrap.querySelectorAll('.tpb-tab-btn').forEach(b => b.classList.remove('active'));
    tabBtn.classList.add('active');
    grid.innerHTML = '<p class="tpb-menu-loading">Loading menuâ€¦</p>';

    const handle = tabBtn.dataset.collection;
    const sidesRequired = parseInt(tabBtn.dataset.sides, 10) || 0;
    const products = await fetchCollection(handle);

    if (!products.length) {
      grid.innerHTML = '<p class="tpb-menu-loading">No items in this category yet.</p>';
      return;
    }

    let visible = products;
    if (availableOnly) {
      visible = products.filter(p => p.variants[0] && p.variants[0].available);
    }
    if (!visible.length) {
      grid.innerHTML = '<p class="tpb-menu-loading">Nothing available right now in this category.</p>';
      return;
    }

    grid.innerHTML = visible.map(p => productCardHTML(p, sidesRequired)).join('');
    wireAddButtons();
  }

  function wireAddButtons() {
    grid.querySelectorAll('.tpb-add-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const sidesRequired = parseInt(btn.dataset.sides, 10) || 0;
        if (sidesRequired > 0) {
          openSidesModal(btn.dataset.variantId, btn.dataset.name, sidesRequired);
        } else {
          addToCart([{ id: btn.dataset.variantId, quantity: 1 }]);
          showToast(`Added ${btn.dataset.name} to cart`);
        }
      });
    });
  }

  async function openSidesModal(variantId, name, required) {
    pendingVariantId = variantId;
    pendingRequired = required;
    selectedSides = [];
    selectedExtras = [];
    sidesItemName.textContent = name;
    sidesEyebrow.textContent = required === 1 ? 'Pick 1 Side' : `Pick ${required} Sides`;
    sidesSub.textContent = required === 1
      ? 'Choose one side dish to go with this plate.'
      : `Choose exactly ${required} side dishes for this plate.`;
    sidesMsg.textContent = '';
    const options = await getSidesOptions();
    renderSidesList(options);
    renderExtrasList(options);
    sidesOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeSidesModal() {
    sidesOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  function renderSidesList(options) {
    sidesList.innerHTML = options.map(o => {
      const checked = selectedSides.includes(o.name);
      const disabled = !checked && selectedSides.length >= pendingRequired;
      return `
        <div class="tpb-side-option ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}" data-side="${o.name}">
          <span class="tpb-side-check">${checked ? 'âœ“' : ''}</span>
          <span>${o.name}</span>
        </div>`;
    }).join('');
    sidesList.querySelectorAll('.tpb-side-option').forEach(el => {
      el.addEventListener('click', () => {
        const side = el.dataset.side;
        if (selectedSides.includes(side)) {
          selectedSides = selectedSides.filter(s => s !== side);
        } else if (selectedSides.length < pendingRequired) {
          selectedSides.push(side);
        }
        renderSidesList(options);
      });
    });
    sidesCount.textContent = `${selectedSides.length} of ${pendingRequired} selected`;
    sidesCount.classList.toggle('full', selectedSides.length === pendingRequired);
    sidesConfirm.disabled = selectedSides.length !== pendingRequired;
  }

  function renderExtrasList(options) {
    const extrasList = document.getElementById('tpbExtrasList');
    if (!extrasList) return;
    extrasList.innerHTML = options.map(o => {
      const checked = selectedExtras.some(e => e.name === o.name);
      const priceLabel = o.price ? ` (+$${o.price.toFixed(2)})` : '';
      return `
        <div class="tpb-side-option tpb-extra-option ${checked ? 'checked' : ''}" data-extra="${o.name}">
          <span class="tpb-side-check">${checked ? 'âœ“' : ''}</span>
          <span>${o.name}${priceLabel}</span>
        </div>`;
    }).join('');
    extrasList.querySelectorAll('.tpb-extra-option').forEach(el => {
      el.addEventListener('click', () => {
        const name = el.dataset.extra;
        const opt = options.find(o => o.name === name);
        if (selectedExtras.some(e => e.name === name)) {
          selectedExtras = selectedExtras.filter(e => e.name !== name);
        } else {
          selectedExtras.push({ name: opt.name, variantId: opt.variantId });
        }
        renderExtrasList(options);
      });
    });
  }

  async function addToCart(items) {
    if (!items || !items.length) return false;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error('cart add failed');
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  sidesConfirm.addEventListener('click', async () => {
    const properties = {};
    selectedSides.forEach((s, i) => { properties[`Side ${i + 1}`] = s; });
    const items = [{ id: pendingVariantId, quantity: 1, properties }];
    selectedExtras.forEach(extra => {
      if (extra.variantId) items.push({ id: extra.variantId, quantity: 1 });
    });
    const ok = await addToCart(items);
    if (ok) {
      const extrasNote = selectedExtras.length ? ` + ${selectedExtras.length} extra${selectedExtras.length > 1 ? 's' : ''}` : '';
      sidesMsg.style.color = 'var(--tpb-copper)';
      sidesMsg.textContent = 'Added to cart!';
      showToast(`Added ${sidesItemName.textContent}${extrasNote} to cart`);
      setTimeout(closeSidesModal, 700);
    } else {
      sidesMsg.style.color = '#E5484D';
      sidesMsg.textContent = 'Something went wrong - please try again.';
    }
  });
  document.getElementById('tpbSidesClose').addEventListener('click', closeSidesModal);
  sidesOverlay.addEventListener('click', (e) => { if (e.target === sidesOverlay) closeSidesModal(); });

  tabsWrap.querySelectorAll('.tpb-tab-btn').forEach(btn => {
    btn.addEventListener('click', () => renderTab(btn));
  });
  if (availToggle) {
    availToggle.addEventListener('change', (e) => {
      availableOnly = e.target.checked;
      renderTab(currentTab);
    });
  }

  if (currentTab) renderTab(currentTab);
})();